import React, { useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import { Button } from '@mui/material';
import DataTransactionTable from "../../components/Table/DataTransaction";
import { useNavigate, useLocation } from 'react-router-dom';
const DataTransaction = () => {
     const navigate = useNavigate();
     const location = useLocation();
    const [reloadKey, setReloadKey] = useState(0)
 
     console.log('location', location)
  return (
     <div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='RegisterProviderText'>
   <div style={{display:"flex",justifyContent:"space-between"}}>
   <span style={{paddingLeft:20}}>Fund Transactions</span>
     </div>     
 
 
     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                            
                           <div style={{width:"98%",marginTop:40}}>
                               <DataTransactionTable reloadKey={reloadKey}/>    
                           </div>  
                             
             </div>
         
 </div>
  )
}

export default DataTransaction